export const productPage = () => {
  const shareButton = document.getElementById("share-button") as HTMLElement;

  if (!shareButton) {
    console.warn("No share button on the page");
    return;
  }

  const shareButtonsContainer = document.getElementById(
    "share-links-container"
  ) as HTMLElement;

  if (!shareButtonsContainer) {
    console.warn("No share links container on the page");
    return;
  }

  /** Hides the share buttons when clicking outside */
  document.addEventListener("click", _ => {
    if (shareButton !== document.activeElement) {
      shareButtonsContainer.classList.add("hidden");
    }
  })

  /** Show/hide the share buttons when share button is clicked */
  shareButton.addEventListener("click", evt => {
    shareButtonsContainer.classList.toggle("hidden");

    evt.preventDefault();
  });
};
